import React from "react";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";

const HatCard = ({ hat }) => {
  return (
    <Card
      sx={{
        backgroundColor: "#f7f7f5",
        borderRadius: "10px",
        padding: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      <CardMedia
        component="img"
        alt={hat.name}
        sx={{
          width: "80%",
          height: "auto",
          margin: "0 auto",
          objectFit: "cover",
        }}
        image={hat.image}
        title={hat.name}
      />

      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6">{hat.name}</Typography>
        <Typography variant="body2">{hat.description}</Typography>
      </CardContent>
    </Card>
  );
};

export default HatCard;
